import posthogInstance from '../packs/posthog';

export default {
  install(Vue, _options) {
    const posthog = posthogInstance || window.posthog;

    Vue.prototype.$posthog = posthog;
  },
};
